<template>
  <div>
    <div id="userUpdateModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modelSingle" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <!--begin::Form-->
        <form class="kt-form" @submit="formSubmit">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="kt-portlet__body">
                <div class="kt-section kt-section--first">
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">ชื่อผู้ใช้งาน (UserName):</label>
                        <input
                          disabled
                          id="userName"
                          name="userName"
                          v-model="userName"
                          type="text"
                          maxlength="256"
                          class="form-control"
                          placeholder="ชื่อผู้ใช้งาน (UserName)"
                        />
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">อีเมล:</label>
                        <input
                          disabled
                          id="email"
                          name="email"
                          v-model="email"
                          type="email"
                          maxlength="256"
                          class="form-control"
                          placeholder="อีเมล"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">โปรไฟล์บริษัท:</label>
                        <!-- <select
                          id="companyProfile"
                          name="companyProfile"
                          class="form-control m-select2"
                          style="width: 100%;"
                        ></select> -->
                        <select2
                          id="useraCompanyProfile"
                          name="useraCompanyProfile"
                          class="form-control m-select2"
                          style="width: 100%;"
                          :select2-options="useraCompanyProfileOptions"
                          v-model="useraCompanyProfile"
                          @selectChange="onCompanyProfileChange"
                          ref="useraCompanyProfileSelect2"
                        ></select2>
                        <br />ไม่พบข้อมูลโปรไฟล์บริษัทคลิกเพื่อสร้าง
                        <a href="javascript:void()" @click="showSubAgentProfileCreateForm">โปรไฟล์ตัวแทนฯย่อย</a>
                        <span class="form-text"></span>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">ชื่อ:</label>
                        <input
                          id="givenName"
                          name="givenName"
                          v-model="givenName"
                          type="text"
                          maxlength="450"
                          class="form-control"
                          placeholder="ชื่อ"
                        />
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">ชื่อสกุล:</label>
                        <input
                          id="familyName"
                          name="familyName"
                          v-model="familyName"
                          type="text"
                          maxlength="450"
                          class="form-control"
                          placeholder="ชื่อสกุล"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>ตำแหน่ง:</label>
                        <input
                          id="position"
                          name="position"
                          v-model="position"
                          type="text"
                          maxlength="450"
                          class="form-control"
                          placeholder="ตำแหน่ง"
                        />
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label class="label-required">เบอร์ติดต่อ:</label>
                        <input
                          id="phoneNumber"
                          name="phoneNumber"
                          v-model="phoneNumber"
                          type="text"
                          maxlength="450"
                          class="form-control"
                          placeholder="เบอร์ติดต่อ"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>วันที่เข้าสู่ระบบล่าสุด:</label>
                        <input disabled name="lastLogOnDateTimeString" v-model="lastLogOnDateTimeString" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>

                  <user-sml-mapping :selectedCompanyProfiles="selectedCompanyProfiles" :userSmlMappings.sync="userSmlMappings"></user-sml-mapping>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="la la-close"></i> ปิดหน้าต่าง</button>
              <button type="submit" class="btn btn-primary"><i class="la la-save"></i> บันทึกข้อมูล</button>
            </div>
          </div>
        </form>
        <!--end::Form-->
      </div>
    </div>
    <sub-agent-profile-create-form ref="subAgentProfileCreateForm"></sub-agent-profile-create-form>
  </div>
</template>

<script>
import subAgentProfileCreateForm from "./SubAgentProfileCreateForm";
import axios from "axios";
import select2 from "../../../Shared/Select2";
import userSmlMapping from "./UserSmlMapping.vue";

export default {
  components: {
    subAgentProfileCreateForm,
    select2,
    userSmlMapping,
  },
  data: function() {
    var self = this;
    return {
      userName: null,
      email: null,
      givenName: null,
      familyName: null,
      position: null,
      phoneNumber: null,
      roleName: null,
      lastLogOnDateTimeString: null,
      companyProfileId: null,
      useraCompanyProfile: null,
      useraCompanyProfileOptions: {
        placeholder: "เลือกโปรไฟล์บริษัท",
        allowClear: true,
        ajax: {
          url: "/Api/CompanyProfile/Options",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      selectedCompanyProfiles: [],
      userSmlMappings: [],
    };
  },
  methods: {
    onCompanyProfileChange(id, value, data, ref) {
      this.selectedCompanyProfiles = data;
    },
    showSubAgentProfileCreateForm: function() {
      $(this.$refs.subAgentProfileCreateForm.$el).modal("show");
    },
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$("#userUpdateModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      var tempCompanyProfile = this.useraCompanyProfile;
      this.useraCompanyProfile = [];
      if (tempCompanyProfile != null) {
        this.useraCompanyProfile.push(tempCompanyProfile);
      }

      let router = this.$router;
      axios
        .post("/Api/Users/Update", {
          userName: this.userName,
          email: this.email,
          givenName: this.givenName,
          familyName: this.familyName,
          position: this.position,
          phoneNumber: this.phoneNumber,
          roleName: this.roleName,
          companyProfileId: this.useraCompanyProfile,
          userSmlMappings: this.userSmlMappings,
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
              $("#userUpdateModal").modal("hide");
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    $.validator.addMethod(
      "regex",
      function(value, element, regexp) {
        var re = new RegExp(regexp);
        return this.optional(element) || re.test(value);
      },
      "Please check your input."
    );

    // set validation rules
    $("#userUpdateModal form").validate({
      rules: {
        userName: "required",
        email: {
          required: true,
          email: true,
        },
        givenName: "required",
        familyName: "required",
        phoneNumber: "required",
        companyProfile: "required",
      },
      messages: {
        userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
        email: {
          required: "กรุณากรอกอีเมล",
          email: "กรุณากรอกอีเมลให้ถูกต้อง",
        },
        givenName: "กรุณากรอกชื่อ",
        familyName: "กรุณากรอกชื่อสกุล",
        phoneNumber: "กรุณากรอกเบอร์โทรศัพท์",
        companyProfile: "กรุณาเลือกโปรไฟล์บริษัทฯ",
      },
    });

    $("#userUpdateModal #companyProfile")
      .select2({
        placeholder: "เลือกโปรไฟล์บริษัท",
        allowClear: true,
        ajax: {
          url: "/Api/CompanyProfile/Options",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      })
      .change(function() {
        self.companyProfileId = $(this).val();
      });

    $("#userUpdateModal").on("hidden.bs.modal", function() {
      // Set go back
      router.go(-1);
      self.$parent.reloadDataTable(false);
    });

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/Users/" + this.$route.params.userId)
      .then(function(response) {
        if (response.status == 200) {
          self.userName = response.data.userName;
          self.email = response.data.email;
          self.phoneNumber = response.data.phoneNumber;
          self.givenName = response.data.givenName;
          self.familyName = response.data.familyName;
          self.position = response.data.position;
          self.lastLogOnDateTimeString = response.data.lastLogOnDateTimeString;
          self.roleName = response.data.roleName;
          // self.companyProfileId = response.data.companyProfileId;
          // self.companyProfileName = response.data.companyProfileName;

          if (self.roleName) {
            $("#userUpdateModal #roleName")
              .append("<option selected value='" + response.data.roleName + "'>" + response.data.roleDescription + "</option>")
              .trigger("change");
          }

          // if (self.companyProfileId) {
          //   $("#userUpdateModal #companyProfile")
          //     .append(
          //       "<option selected value='" +
          //         response.data.companyProfileId +
          //         "'>" +
          //         response.data.companyProfileName +
          //         "</option>"
          //     )
          //     .trigger("change");
          // }

          self.userSmlMappings = response.data.userSmlMappings;

          if (response.data.companyProfiles) {
            var companyOptions = $.map(response.data.companyProfiles, function(obj, idx) {
              return {
                id: obj.companyProfileId,
                text: obj.companyProfileName,
                data: obj.data,
              };
            });
            self.$refs.useraCompanyProfileSelect2.setSelectedData(companyOptions);
          }

          $("#userUpdateModal").modal("show");
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสมาชิกที่คุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสมาชิกได้ในขณะนี้", "error");
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/User/AgentUserUpdate.vue